import React from 'react';
import cx from 'classnames';
import { useGetComplexStatuses } from 'src/hooks';
import { useStyles } from './styles';

interface Props {
  size?: number;
  topLeft?: string;
  bottomRight?: string;
  className?: string;
}
export const PolygonsSwitchLogo: React.FC<Props> = ({
  size = 24, topLeft = '#FFB48A', bottomRight = '#6F95C8', className,
}) => {
  const { statuses } = useGetComplexStatuses();

  const _topLeft = statuses[0]?.color || topLeft;
  const _bottomRight = statuses[1]?.color || bottomRight;
  const styles = useStyles({ size, topLeft: _topLeft, bottomRight: _bottomRight });
  return (
    <div className={cx(styles.root, className)}>
      <svg
        className={styles.svg}
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={styles.blue}
          d="M21.7204 13.1238H10.8428V23.9997H21.7204V13.1238Z"
        />
        <path
          className={styles.topLeft}
          d="M0 2.2502V13.1262H10.8777V0L0 2.2502Z"
        />
      </svg>
    </div>
  );
};
